import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import AlbumsForm from '../mixins/AlbumsForm';

class Album extends Component {
    constructor(props) {
      super(props);

      this.state = {
        album: [],
        id: '',
        edit: false
      };

      this.getAlbum = this.getAlbum.bind(this);
    }

    componentDidMount(props) {
        const { id } = this.props.album;

        this.setState({
            id,
            album: this.props.album
        });
    }

    getAlbums() {
        this.props.getAlbums();
    }

    getAlbum(album) {
        this.setState({ album: album, edit:false });
        this.getAlbums();
    }

    render() {
        const { id, title, description, uri } = this.state.album;

        const edit = this.state.edit;
        const btnText = this.state.edit ? 'Close' : 'Update';

        return (
            <div className="col-md-5">
                {<div className="card bg-light mb-2">
                    <Link to={`albums/${id}`}>
                        <h5 className="card-header"><img className="img-fluid" src={'/'+uri} alt={title}/></h5>
                        <div className="card-body">
                            <h5 className="card-title">{title}</h5>
                            <p className="card-text">{description}</p>
                        </div>
                    </Link>
                            {user.admin && edit ? (
                                <AlbumsForm album={this.props.album} key={id} getAlbum={this.getAlbum}/>
                            ) : null}
                            {user.admin ?
                                <button
                                    className={this.state.edit ? 'btn btn-danger' : 'btn btn-primary'}
                                    onClick={() => this.setState({edit: !this.state.edit})}>{btnText}
                                </button>
                            : null}
                </div>}
            </div>
        );
    }
}

Album.propTypes = {
    album: PropTypes.object.isRequired,
    getAlbums: PropTypes.func.isRequired
};

export default Album;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Album.js